import { render, staticRenderFns } from "./AgregarEstudios.vue?vue&type=template&id=e963314e&scoped=true"
import script from "./AgregarEstudios.vue?vue&type=script&lang=js"
export * from "./AgregarEstudios.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AgregarEstudios.vue?vue&type=style&index=1&id=e963314e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e963314e",
  null
  
)

export default component.exports